<template>
  <div class="card-header d-flex justify-content-between align-items-center">
    <h4 class="card-header-title mb-0 font-weight-bold">IDP Enrollment</h4>
    <b-button v-if="isEnabled" variant="primary" @click="$emit('open-add')">
      <span>{{ activeTab === "social_learning" ? "Add Coaching" : "Add Project" }}</span>
    </b-button>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    activeTab: {
      type: String,
      default: null,
    },
  },
  computed: {
    isEnabled() {
      return this.activeTab === "social_learning" || this.activeTab === "experiential_learning";
    },
  },
};
</script>
